import pgrc1to6Module from '../reports/progress-gr1-6-2023-07/index.js';
import provincialModule from '../reports/provincial-gr1-6-2023-09/index.js';

export const REPORT_TYPES = [
  {
    value: "pgrc1to6_2023_07",
    label: "Progress Report",
    subtitle: "Grades 1–6",
    description: "Ontario's standard elementary progress report covering learning skills and subject areas.",
    pdfPreview: pgrc1to6Module.templateUrl,
    grades: [1, 2, 3, 4, 5, 6],
    disabled: false,
    registryKey: 'pgrc1to6_2023_07',
  },
  {
    value: "pvrc1to6_2023_09",
    label: "Provincial Report",
    subtitle: "Grades 1–8",
    description: "Full provincial report card with detailed subject-by-subject letter grades.",
    pdfPreview: provincialModule.templateUrl,
    grades: [1, 2, 3, 4, 5, 6, 7, 8],
    disabled: false,
    registryKey: 'pvrc1to6_2023_09',
  },
  {
    value: "pgrc1to6_fr",
    label: "Progress Report — French Immersion",
    subtitle: "Grades 1–6",
    description: "Progress report adapted for French Immersion classrooms.",
    pdfPreview: null,
    grades: [1, 2, 3, 4, 5, 6],
    disabled: true,
    registryKey: null,
  },
  {
    value: "provincial_jr",
    label: "Junior/Intermediate Provincial",
    subtitle: "Grades 4–8",
    description: "Provincial report card tailored for junior and intermediate division students.",
    pdfPreview: null,
    grades: [4, 5, 6, 7, 8],
    disabled: true,
    registryKey: null,
  },
  {
    value: "iep_modified",
    label: "Modified Expectations",
    subtitle: "Grades 1–8",
    description: "IEP-aligned report card for students with modified learning expectations.",
    pdfPreview: null,
    grades: [1, 2, 3, 4, 5, 6, 7, 8],
    disabled: true,
    registryKey: null,
  },
];

export function getTypeLabelByValue(value) {
  return REPORT_TYPES.find((t) => t.value === value)?.label ?? value;
}
